import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Header, MenuGroup, MenuIcon, MenuItemContainer, Nav, SubMenu, ToolTip } from "./styels";
import { useTranslation } from "react-i18next"; // react-i18next hook for translations
import { useDispatch, useSelector } from "react-redux";
import { clearMenu, currentMenu, menuStatus, openedMenu, selectedMenu } from "../../../../../store/actions/common";
import { CloseIcon, GetIcon } from "../../../../../icons";
import { Logo, MNavClose } from "../header/styels";
import { logo } from "../../../../../images";
import { clearLogin } from "../../../../../store/actions/login";
import i18n from "i18next"; // i18n library for internationalization
import { postData } from "../../../../../backend/api";
import AutoForm from "../../../../elements/form";
import { createPortal } from 'react-dom';
import { useRef } from "react";

const SubMenuData = ({menuItem, index, submenu, t, openedMenus, dispatch, selectedMenuItem, handleLanguageChange,setShowResetPassword}) => {

  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef(null);

  useEffect(() => {
    if (showTooltip && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top + window.scrollY + 18,
        left: rect.right , // adjust tooltip to the right of the icon
      });
    }
  }, [showTooltip]);

  return (
    <>
      <Link
          ref={iconRef}
          onMouseEnter={() => setShowTooltip(submenu._id)}
        onMouseLeave={() => setShowTooltip(false)}
        style={{fontSize:'14px',position:'relative', borderRadius: '6px'}}
            key={submenu._id} // Use submenu.label as the key
            onClick={() => {
              if (submenu.label === "logout") {
                dispatch(clearLogin());
              } else if (submenu.label === "languageSwitch") {
                handleLanguageChange();
              } else if (submenu.label === "resetPassword") {
                setShowResetPassword(true);
              } else {
                dispatch(menuStatus(false));
                // dispatch(selectedMenu(submenu));
                dispatch(selectedMenu({ ...submenu, parent: menuItem._id }));
                dispatch(currentMenu(submenu.label)); // Use submenu.label in currentMenu dispatch
              }
            }}
            className={submenu._id === selectedMenuItem._id ? "main active submenu" : "main submenu"} // Use submenu.path for the active class
            to={submenu.path} // Use submenu.path for the link destination
          >
            <GetIcon color={submenu._id === selectedMenuItem._id ? "white":""} icon={submenu.icon} fontSize="20px !important" />
            {sessionStorage.getItem("small-menu")==="false" && <span> {t(submenu.label)}</span>} {/* Use submenu.label for the link text */}
            {showTooltip===submenu._id && createPortal(
            <ToolTip style={{
              display: sessionStorage.getItem("small-menu")==="false" ? 'none':'block',
              top: tooltipPosition.top,
              left: tooltipPosition.left,
            }}>
          {t(submenu.label)} 
          {/* <span>{index+1}</span> */}
        </ToolTip>,
        document.body
      )}
    </Link>
  </>
  );
}

const MenuData = ({user, menuItem, index, submenu, t, openedMenus, dispatch, selectedMenuItem, handleLanguageChange,setShowResetPassword})=>{
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const iconRef = useRef(null);

  useEffect(() => {
    if (showTooltip && iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top + window.scrollY + 18,
        left: rect.right , // adjust tooltip to the right of the icon
      });
    }
  }, [showTooltip]);

  return (
    <MenuItemContainer menu={sessionStorage.getItem("small-menu")==="false"?"230px":"65px"} className={`${(user.authorisation==="advisor" && user.company !== null && sessionStorage.getItem("selected-company")) ? "advisor-menu" : ""} ${menuItem.label}`} key={menuItem._id} >
      {menuItem.submenus?.length > 0 ? (
        <React.Fragment key={`link-${menuItem._id}`}>
          <MenuGroup>
            <Link
            ref={iconRef}
            onMouseEnter={() => setShowTooltip(menuItem._id)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{fontSize:'14px',position:'relative'}}
              to={submenu.path}
              onClick={(e) => {
                const menuItemId = menuItem._id;
                const openedMenuStatus = openedMenus?.[menuItemId];
                if (menuItem._id !== selectedMenuItem.parent) {
                  // Dispatch actions
                  dispatch(menuStatus(false));
                  dispatch(selectedMenu({ ...submenu, parent: menuItem._id }));
                  dispatch(currentMenu(submenu.label)); // Use submenu.label in currentMenu dispatch
                } else {
                  e.preventDefault();
                }
                // Dispatch the openedMenu action
                dispatch(openedMenu(menuItemId));
              }}
              className={openedMenus?.[menuItem._id] === true ? "open active submenu" : " open submenu"}
            >
              <GetIcon icon={menuItem.icon} fontSize="20px !important" /> 
              {sessionStorage.getItem("small-menu")==="false" && <span style={{marginRight: '10px'}}>{t(menuItem.label)}</span> }
              <GetIcon icon={"down"} fontSize="20px !important" />
              {showTooltip===menuItem._id && createPortal(
            <ToolTip style={{
              display: sessionStorage.getItem("small-menu")==="false" ? 'none':'block',
              top: tooltipPosition.top,
              left: tooltipPosition.left,
            }}>
              {t(menuItem.label)} 
              {/* <span>{index+1}</span> */}
            </ToolTip>,
            document.body
          )}
            </Link>
          </MenuGroup>
          <SubMenu className={openedMenus?.[menuItem._id] === true ? "down" : "close"}>
            {menuItem.submenus?.map((submenu,subIndex) => (
              <SubMenuData menuItem={menuItem} index={subIndex} submenu={submenu} t={t} openedMenus={openedMenus} dispatch={dispatch} selectedMenuItem={selectedMenuItem} handleLanguageChange={handleLanguageChange} setShowResetPassword={setShowResetPassword} />
            ))}
          </SubMenu>
        </React.Fragment>
      ) : (
        <Link
        ref={iconRef}
        onMouseEnter={() => setShowTooltip(menuItem._id)}
            onMouseLeave={() => setShowTooltip(false)}
            style={{fontSize:'14px',position:'relative'}}
          key={`link-Main-${menuItem._id}`}
          onClick={() => {
            if (menuItem.label === "logout") {
              dispatch(clearLogin());
            } else if (menuItem.label === "languageSwitch") {
              handleLanguageChange();
            } else {
              dispatch(menuStatus(false));
              // dispatch(selectedMenu(menuItem));
              dispatch(selectedMenu({ ...menuItem, parent: menuItem._id }));
              dispatch(currentMenu(menuItem.label));
              dispatch(clearMenu(""));
            }
          }}
          className={menuItem._id === selectedMenuItem._id ? "main active" : "main"}
          to={menuItem.path}
        >
          <GetIcon color={menuItem._id === selectedMenuItem._id ? "white":""} icon={menuItem.icon} fontSize="20px !important" /> 
          {sessionStorage.getItem("small-menu")==="false" && <span>{menuItem.path==='/leave-request'?(sessionStorage.getItem("small-menu")==="false" && sessionStorage.getItem("_lang")!=="en") ? t("leave-request").replace(/\s/g,''):t("leave-request"):menuItem.path==='/work-log'? (sessionStorage.getItem("small-menu")==="false" && sessionStorage.getItem("_lang")!=="en") ? t("work-log").replace(/\s/g,''):t("work-log"):t(menuItem.label)}</span>}

          {showTooltip===menuItem._id && createPortal(
            <ToolTip style={{
              display: sessionStorage.getItem("small-menu")==="false" ? 'none':'block',
              top: tooltipPosition.top,
              left: tooltipPosition.left,
            }}>
              {t(menuItem.label)} 
              {/* <span>{index+1}</span> */}
            </ToolTip>,
            document.body
          )}
        </Link>
      )}
    </MenuItemContainer>
  );
}

const Menu = (props) => {
  const { t } = useTranslation();
  const themeColors = useSelector((state) => state.themeColors);
  const openedMenus = useSelector((state) => state.openedMenu);
  const selectedMenuItem = useSelector((state) => state.selectedMenu);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language || "de");
  const [showTooltip, setShowTooltip] = useState(false);
  const location = useLocation();
  const formInput = [
    {
      type: "password",
      placeholder: "currentPassword",
      name: "currentPassword",
      validation: "",
      default: "",
      label: "currentPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
    {
      type: "password",
      placeholder: "newPassword",
      name: "newPassword",
      validation: "passwordMatch",
      default: "",
      label: "newPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
    {
      type: "password",
      placeholder: "confirmPassword",
      name: "confirmPassword",
      validation: "passwordMatch",
      default: "",
      label: "confirmPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
  ];
  const dispatch = useDispatch();
      const navigate = useNavigate();
  const handleLanguageChange = (language) => {
    // Change the language in the i18n library
    if (selectedLanguage === "en") {
      i18n.changeLanguage("de");
      setSelectedLanguage("de");
      sessionStorage.setItem("_lang", "de");
    } else {
      i18n.changeLanguage("en");
      setSelectedLanguage("en");
      sessionStorage.setItem("_lang", "en");
    }
  };
  const [showResetPassword, setShowResetPassword] = useState(false);
  const isCreatingHandler = (value, callback) => {
    setShowResetPassword(false);
  };
  const submitChange = async (post) => {
    //call set password with
    props.setLoaderBox(true);
    await postData({ ...post }, "user/reset-password", dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          props.setMessage({
            type: 1,
            content: t(response.data.message),
            okay: "Okay",
            code: 200,
            onClose: () => {},
          });
          props.setLoaderBox(false);
        } else if (response.status === 201) {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 201 });
          props.setLoaderBox(false);
        } else {
          props.setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 500 });
          props.setLoaderBox(false);
        }
        setShowResetPassword(false);
        props.setLoaderBox(false);
      })
      .catch((error) => {
        props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        props.setLoaderBox(false);
      });
  };

  useEffect(() => {
    if(location.pathname){
      dispatch(menuStatus(false));
      
      const matchedItem = props.user.menu?.find((menuItem) => {
        // Check if the menuItem path matches
        if (menuItem.path === location.pathname) {
          return true;
        }
      
        // Check if any submenu path matches
        return menuItem.submenus?.some((submenu) => submenu.path === location.pathname);
      });
      
      if (matchedItem) {
        // Check if menuItem itself matches
        if (matchedItem.path === location.pathname) {
          dispatch(currentMenu(matchedItem.label));
          dispatch(selectedMenu({ ...matchedItem, parent: matchedItem._id }));
        } else {
          // If submenu matches, find and return the matching submenu with the parent's ID
          const matchedSubmenu = matchedItem.submenus?.find(
            (submenu) => submenu.path === location.pathname
          );
          if (matchedSubmenu) {
            dispatch(currentMenu(matchedSubmenu.label));
            dispatch(selectedMenu({ ...matchedSubmenu, parent: matchedItem._id }));
          }
        }
      }
      
      
    }
  }, [location.pathname])


  return (
    <>
      <Header style={{ display: "none" }} className="hm">
        <MenuIcon
          onClick={() => {
            props.changeMenu();
          }}
        >
          <GetIcon icon={"menu"} />
        </MenuIcon>
        <Logo className="menu" src={logo} alt="logo" />
        {/* <User>{props.user.user.email}</User> */}
        <MNavClose
          onClick={() => {
            dispatch(menuStatus(false));
          }}
        >
          <CloseIcon />
        </MNavClose>
      </Header>
      {/* <NavIcon className="menu">
        <img src={nav} alt="logo" />
      </NavIcon> */}
      <Nav theme={themeColors}>
        {/* Link to the home page */}
        {props.user.menu?.map((menuItem,index) => {
          const submenu = menuItem.submenus?.[0];
          return (
            <MenuData user={props.user.user} menuItem={menuItem} index={index} submenu={submenu} t={t} openedMenus={openedMenus} dispatch={dispatch} selectedMenuItem={selectedMenuItem} handleLanguageChange={handleLanguageChange} setShowResetPassword={setShowResetPassword} />
          );
        })}
      </Nav>
      {showResetPassword && <AutoForm formMode={"single"} enterSubmit={true} useCaptcha={false} formType={"post"} header={t("resetPassword")} formInput={formInput} submitHandler={submitChange} button={t("confirm")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={false}></AutoForm>}
    </>
  );
};

export default Menu;
